import { resolveResponsive, } from "@emkit/builder-core";
const SECTION_MAX_WIDTH = {
    full: "100%",
};
function spacingStyle(s) {
    if (!s)
        return undefined;
    const { top = 0, right = 0, bottom = 0, left = 0 } = s;
    return `${top}px ${right}px ${bottom}px ${left}px`;
}
function backgroundShorthand(bg) {
    if (!bg || bg.kind === "none")
        return undefined;
    if (bg.kind === "color")
        return bg.color;
    if (bg.kind === "image") {
        const size = bg.size ?? "cover";
        const pos = bg.position ?? "center";
        return `url("${bg.url}") ${pos}/${size} no-repeat`;
    }
    // Video: handled by a sibling <video> element; section bg stays default.
    return undefined;
}
function resolvePadding(padding, breakpoint) {
    if (padding === undefined)
        return undefined;
    return resolveResponsive(padding, breakpoint);
}
function resolveMaxWidth(maxWidth, breakpoint) {
    if (maxWidth === undefined)
        return "1200px";
    const v = resolveResponsive(maxWidth, breakpoint);
    if (typeof v === "number")
        return `${v}px`;
    return SECTION_MAX_WIDTH[v] ?? "1200px";
}
export function buildSectionStyle(section, breakpoint) {
    const padding = resolvePadding(section.padding, breakpoint);
    const maxWidth = resolveMaxWidth(section.maxWidth, breakpoint);
    const bg = backgroundShorthand(section.background);
    return {
        outer: {
            position: "relative",
            width: "100%",
            background: bg,
        },
        inner: {
            position: "relative",
            zIndex: 1,
            margin: "0 auto",
            maxWidth,
            display: "grid",
            gridTemplateColumns: "repeat(12, minmax(0,1fr))",
            gap: "16px",
            padding: spacingStyle(padding),
        },
        hasVideoBackground: section.background?.kind === "video",
    };
}
export function buildColumnStyle(column, breakpoint) {
    const span = column.span ? resolveResponsive(column.span, breakpoint) : 12;
    const gap = column.gap ? resolveResponsive(column.gap, breakpoint) : 16;
    const clamped = Math.min(Math.max(span, 1), 12);
    return {
        gridColumn: `span ${clamped}`,
        display: "flex",
        flexDirection: "column",
        gap: `${gap}px`,
        minWidth: 0,
    };
}
/** Convert a camelCase StyleObject into an inline CSS string. */
export function styleObjectToCssString(obj) {
    const out = [];
    for (const [key, value] of Object.entries(obj)) {
        if (value === undefined || value === null || value === "")
            continue;
        const kebab = key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
        out.push(`${kebab}:${value}`);
    }
    return out.join(";");
}
//# sourceMappingURL=style.js.map